export default __webpack_public_path__ + "static/media/plane-up.438193bf.svg";